import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import PartnerAccountForm from '../../PartnerAccountForm'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { formatValuesToBE } from './formatter'

import { updateSelfAccount, clearUpdateSelfAccount } from '../../../../../../modules/actions/selfAccounts'
import {
  updateSelfAccountIsLoadingSelector,
  updateSelfAccountErrorSelector,
  updateSelfAccountWasUpdatedSelector,
  selfAccountSelector
} from '../../../../../../modules/selectors/selfAccounts'

import { getInitialValues, validationSchema } from '../../PartnerAccountForm/fields'
import { PARTNER_ACCOUNT_EDIT } from '../../../../../../constants/forms'

const EditPartnerAccountForm = () => {
  const dispatch = useDispatch()
  const selfAccount = useSelector(selfAccountSelector)

  const wasSelfAccountUpdated = useSelector(updateSelfAccountWasUpdatedSelector)

  const onSubmit = useCallback(
    values => {
      const formattedValues = formatValuesToBE(values)
      dispatch(updateSelfAccount(selfAccount.id, formattedValues))
    },
    [dispatch, selfAccount.id]
  )

  const formik = useFormik({
    initialValues: getInitialValues(selfAccount),
    validationSchema,
    onSubmit,
    enableReinitialize: true
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const clearCreatePartnershipHandler = useCallback(() => {
    dispatch(clearUpdateSelfAccount())
  }, [dispatch])

  return (
    <PartnerAccountForm
      formName={PARTNER_ACCOUNT_EDIT}
      formik={purifiedFormik}
      successSubmit={wasSelfAccountUpdated}
      errorSelector={updateSelfAccountErrorSelector}
      isLoadingSelector={updateSelfAccountIsLoadingSelector}
      clearHandler={clearCreatePartnershipHandler}
      isEditForm={true}
    />
  )
}

export default EditPartnerAccountForm
